export enum ContainerCardContentTheme {
  DEFAULT = 'default',
  TRANSPARENT = 'transparent',
  DARK = 'dark',
  LIGHT = 'light',
}
